// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "202609291438-" + chunkId + ".bundle.js";
};